import { FC, useState } from "react";
import StandardNewsletterForm from "./StandardNewsletterForm";
import MinimalNewsletterForm from "./MinimalNewsletterForm";
import useNewslettersSubscription from "@/custom_hooks/useNewslettersSubcription";
import useForm from "@/custom_hooks/useForm";

const NewsletterForm: FC<{ variant?: "standard" | "minimal" }> = ({
  variant = "standard",
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    formData,
    formMessages: { setErrorMsg, errorMsg, successMsg, setSuccessMsg },
    onInputChange,
  } = useForm({ full_name: "", email: "" });
  const { ConfirmationCheckbox, subscribe } = useNewslettersSubscription(
    setErrorMsg,
    setSuccessMsg,
    setIsLoading,
  );

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    await subscribe(formData.email);
  };

  const Form =
    variant === "standard" ? StandardNewsletterForm : MinimalNewsletterForm;

  return (
    <Form
      email={formData.email}
      name={formData.full_name}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      onChange={onInputChange}
      errorMsg={errorMsg}
      successMsg={successMsg}
      checkbox={<ConfirmationCheckbox className="mt-6" />}
    />
  );
};

export default NewsletterForm;
